export default {"src":"/_next/static/media/duration-clock.899684d6.svg","height":13,"width":12};